import { observer } from 'mobx-react';
import React, { useMemo, useState } from 'react';

import { Box } from '@mui/material';
import Async from 'components/Async';

// import ServiceRouter from '@common/components/ServiceRouter';
import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

import WeekView from '../../components/WeekView';
import GradeBookHeader from '../../components/Header';
import GradeBookLessonView from '../../components/LessonView';
import GradeBookLessons from '../../components/Lessons';
import useGradeBookLogic from '../../hooks/useGradeBookLogic';

function GradeBook() {
	const { gradeBooks, setDateTime, dateTime, format, onSetFormat } = useGradeBookLogic();
	const [selectedLessonId, setSelectedLessonId] = useState<number | null>(null);

	const selectedLesson = useMemo(() => {
		if (!gradeBooks?.data) return null;
		return (
			gradeBooks.data.find((lesson: IClientGradeBookModel) => lesson.id === selectedLessonId) ||
			null
		);
	}, [gradeBooks?.data, selectedLessonId]);

	const handleSelectLesson = (lesson?: IClientGradeBookModel | null) => {
		setSelectedLessonId(lesson?.id ?? null);
	};

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				gap: '16px',
			}}
		>
			<GradeBookHeader
				format={format}
				setDateTime={setDateTime}
				onSetFormat={onSetFormat}
				dateTime={dateTime}
				gradeBooks={gradeBooks}
			/>
			{selectedLesson ? (
				<Box padding="0 8px">
					<GradeBookLessonView gradeBook={selectedLesson} onBack={() => handleSelectLesson(null)} />
				</Box>
			) : (
				<Async loading={gradeBooks.loading}>
					{format === 'day' ? (
						<GradeBookLessons
							gradeBooks={
								gradeBooks.hasGrades && gradeBooks.groupLessonsByDayWithGaps[dateTime.toISODate()]
							}
							mode="day"
							onSelectLesson={handleSelectLesson}
						/>
					) : (
						<WeekView
							days={gradeBooks.hasGrades && gradeBooks.groupLessonsByDayWithGaps}
							onSelectLesson={handleSelectLesson}
						/>
					)}
				</Async>
			)}
		</Box>
	);
}

export default observer(GradeBook);
